<template>
  <div>
    <b-row>
      <div class="col">
        <b-table v-show="cms.length > 0" striped hover :fields="columns" :items="cms" head-variant="light" responsive>
          <template #cell(owner)="cms">
            {{ cms.item.owner.fullName  }}
          </template>
          <template #cell(state)="cms">
            {{ cms.item.state ? 'Publicado' : 'Archivado'  }}
          </template>
          <template #cell(date)="cms">
            {{ moment(cms.item.createdAt).format('YYYY-MM-DD hh:mm:ss a')  }}
          </template>
          <template #cell(actions)="cms">
            <div>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Ver información</span>
                </template>
                <button type="button" @click="() => openModal(cms.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-eye text-blue" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Editar</span>
                </template>
                <button type="button" @click="() => sendEditId(cms.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-pencil text-blue" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ !cms.item.state ? 'Publicar' : 'Archivar'}}</span>
                </template>
                <button type="button" @click="() => postState(cms.item)" class="btn btn-light mr-2">
                  <i :class="cms.item.state ? 'fa fa-check-square-o text-green' : 'fa fa-square-o text-danger'" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Eliminar</span>
                </template>
                <button type="button" @click="() => deletePost(cms.item)" class="btn btn-light mr-2">
                  <i class="fa fa-trash text-red" />
                </button>
              </a-tooltip>
            </div>
          </template>
        </b-table>
        <emptyTable v-show="cms.length < 1" />
      </div>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.rows"
          :per-page="pagination.perPage"
          @input="search()"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
      <b-col class="text-right">
        {{ pagination.rows }} resultados
      </b-col>
    </b-row>
    <b-modal id="preview" ref="modal" size="lg" :title="'Post #'+ preview.id" hide-footer>
      <div class="card-body pt-3 pb-0">
        <b-row>
          <b-col xl="1" class="p-0">
            <b-img left style="width:100%;" :src="`${preview.owner.pathAvatar}?tr=w-500,h-530,fo-auto/tr:r-max`" shape="circle" fluid alt="Fluid image"></b-img>
          </b-col>
          <b-col>
            <div class="mb-2 pt-2">
              <a class="font-weight-bold" href="javascript: void(0);">{{preview.owner.fullName}}</a> · {{ moment(preview.createdAt).format('DD-MMM-YYYY') }}
            </div>
            <div>
              <h5
                class="text-dark font-weight-bold mb-2"
              >{{preview.title}}</h5>
            </div>
            <div class="ql-editor p-0" style="min-height: auto; height: auto; overflow: hidden;">
              {{ simplifyText(preview.description) }}
              <div v-html="viewFrame(preview.description)"></div>
            </div>
            <div v-show="preview.categories.length > 0" class="mb-1 mt-3">
              <a v-for="(category, id) in preview.categories" v-bind:key="id"
                href="javascript: void(0);"
                class="badge text-blue text-uppercase bg-light font-size-12 mr-2"
              >{{ category.name }}</a>
            </div>
            <img v-show="preview.pathBanner !== '' && preview.pathBanner !== null" :src="preview.pathBanner" alt="..." style="margin: auto; display: block; max-width: 100%;"><br/>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import { VueEditor } from 'vue2-editor'
// import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'
import moment from 'moment'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    emptyTable,
  },
  name: 'cmsList',
  props: {
    // dataInfo: {
    //   type: Object,
    // },
  },
  data() {
    return {
      VueEditor,
      moment,
      columns: [
        { key: 'id', label: 'Código', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'title', label: 'Titulo', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'owner', label: 'Creador', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'state', label: 'Estado', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'date', label: 'Fecha de Creación', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      cms: [],
      search: '',
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      preview: {
        id: '',
        title: '',
        description: '',
        categories: [],
        owner: {},
        pathBanner: '',
      },
    }
  },
  created: function () {
  },
  mounted: function () {
    this.searchCms()
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    onHidden (e) {
    },
    postState(post) {
      apiClient.patch(`/cms/${post.id}/state`).then(response => {
        const text = post.state ? 'archivado' : 'publicado'
        Toast.fire({
          icon: 'success',
          title: 'Post ' + text + ' correctamente',
        })
        this.searchCms()
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    openModal(id) {
      apiClient.get(`/cms/${id}`).then(response => {
        this.preview = response.data
        this.$bvModal.show('preview')
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    deletePost(cms) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Desea eliminar el post ' + cms.title + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient.delete(`/cms/${cms.id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Post eliminado correctamente',
            })
            this.searchCms()
          }).catch(error => {
            Toast.fire({
              icon: 'warning',
              title: 'Ooops ocurrió un error' + showErrorMessage(error),
            })
          })
        }
      })
    },
    clean() {
      this.search = ''
    },
    searchCms() {
      let q = ''
      if (this.search) {
        q += '&search=' + this.search
      }
      apiClient.get(`/cms?page=${this.pagination.currentPage - 1}&perpage=${this.pagination.perPage + q}`).then(response => {
        this.cms = response.data.results.rows
        this.pagination.rows = response.data.results.totalPosts
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    sendEditId(id) {
      const isEditing = {
        id: id,
        value: true,
      }
      this.$emit('editing', isEditing)
    },
    simplifyText(text, type) {
      let beforeTag = ''
      const start = text.indexOf('&lt;')
      const end = text.lastIndexOf('&gt;')
      const frame = text.substring(start, end + 4)
      const cleanText = text.split(frame).join('')
      const description = cleanText.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>|<!--.*?-->|&nbsp;/gi, (match, tag) => {
        if (tag === 'br') {
          if (beforeTag === '/p') {
            beforeTag = tag
            return '' // Don't remove line breaks
          } else {
            beforeTag = tag
            return '\n'
          }
        } else if (match === '&nbsp;') {
          beforeTag = tag
          return ' ' // Replace &nbsp; with a space
        } else if (tag === '/p') {
          beforeTag = tag
          return '\n' // Remove everything else
        } else {
          beforeTag = tag
          return '' // Remove everything else
        }
      })
      return description
    },
    viewFrame: function(text) {
      const start = text.indexOf('&lt;')
      const end = text.lastIndexOf('&gt;')
      const frame = text.substring(start, end + 4)
      return frame.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    },
  },
}
</script>
